import { GtagService } from 'app/services/gtag.service';

// Eventos do funil do orçamento (ORCA-1923). Complementam os eventos já existentes
// (dialog_proposal_sent_whatsapp, proposal_sent_email, proposal_item_add etc.) com um
// nome único por etapa, para montar o funil no GA4 sem juntar vários eventos.

export type ProposalSendChannel = 'whatsapp' | 'link' | 'pdf' | 'email';

interface FunnelProposal {
    id?: number | null;
    proposalNumber?: number | string | null;
}

function isFirstProposal(proposal: FunnelProposal | null | undefined): boolean {
    return Number(proposal?.proposalNumber) === 1;
}

/** Marca uma vez por orçamento (no navegador) para não repetir o "first_*" a cada reenvio. */
function onceForProposal(key: string, proposalId: number | null | undefined): boolean {
    if (!proposalId) {
        return true;
    }
    const storageKey = `orca_${key}_${proposalId}`;
    try {
        if (localStorage.getItem(storageKey)) {
            return false;
        }
        localStorage.setItem(storageKey, '1');
    } catch {
        // Sem storage (modo privado): envia mesmo assim.
    }
    return true;
}

function clean(payload: Record<string, any>): Record<string, any> {
    Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key];
        }
    });
    return payload;
}

/** Orçamento criado: dispara first_proposal_created no orçamento nº 1 da conta. */
export function trackProposalCreated(gtag: GtagService, proposal: FunnelProposal | null | undefined): void {
    if (!isFirstProposal(proposal) || !onceForProposal('first_proposal_created', proposal?.id)) {
        return;
    }
    gtag.event('first_proposal_created', clean({
        event_category: 'onboarding',
        event_label: 'Primeiro orçamento da conta criado',
        proposal_id: proposal?.id,
    }));
}

/**
 * Orçamento enviado por qualquer canal: proposal_send { channel, ui_source }
 * e, no orçamento nº 1, first_proposal_sent (uma vez).
 */
export function trackProposalSend(
    gtag: GtagService,
    proposal: FunnelProposal | null | undefined,
    channel: ProposalSendChannel,
    uiSource: 'dialog_after_create' | 'proposal_actions',
): void {
    const payload = clean({
        event_category: 'proposal_delivery',
        event_label: 'Orçamento enviado',
        proposal_id: proposal?.id,
        proposal_number: proposal?.proposalNumber,
        channel,
        ui_source: uiSource,
    });

    gtag.event('proposal_send', payload);

    if (isFirstProposal(proposal) && onceForProposal('first_proposal_sent', proposal?.id)) {
        gtag.event('first_proposal_sent', { ...payload, event_category: 'onboarding', event_label: 'Primeiro orçamento da conta enviado' });
    }
}
